import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: "formly-field-datetimepicker",
    templateUrl: "./datetimepicker.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldDateTimepicker extends FieldType<FieldTypeConfig> {
}
